import axios, { AxiosResponse, InternalAxiosRequestConfig } from 'axios'
import qs from 'query-string'

// ------cookie
axios.defaults.withCredentials = true

const requestInterceptor = (config: InternalAxiosRequestConfig) => {
  return config
}

const responseInterceptor = (res: AxiosResponse) => {
  return res.data
}

// const responseErrorInterceptor = (error) => {
//   if (error.response) {
//     // The server responded with status code outside 2xx
//     console.error('Error response:', error.response)

//     // If backend sends JSON but axios doesn’t parse (Content-Type issue), handle manually:
//     let data = error.response.data
//     if (typeof data === 'string') {
//       try {
//         data = JSON.parse(data)
//       } catch (e) {
//         // leave as string
//       }
//     }

//     return Promise.reject(data)
//   } else if (error.request) {
//     // Request made but no response
//     console.error('No response:', error.request)
//     return Promise.reject({ message: 'No response from server' })
//   } else {
//     // Something else happened
//     console.error('Error setting up request:', error.message)
//     return Promise.reject({ message: error.message })
//   }
// }

/**
 * Axios instance with error handler
 */
const ajaxBot = axios.create({
  baseURL: '/',
  timeout: 60000,
  paramsSerializer: {
    serialize: (params) => qs.stringify(params),
  },
})

// ajaxBot.interceptors.response.use(responseInterceptor, responseErrorInterceptor)
ajaxBot.interceptors.response.use(responseInterceptor)
ajaxBot.interceptors.request.use(requestInterceptor)

export default ajaxBot
